import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import Insurance from "@/shared/model/Insurance";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";

interface Props {
  insurance:Insurance
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'StoreItemInsuranceCardComponent',
  props: {
    insurance: {}
  },
  setup(__props: any) {


const props = __props





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogCard, null, {
    default: _withCtx(() => [
      _createVNode(SogCardTitle, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.insurance.insuranceNumber), 1)
        ]),
        _: 1
      }),
      _createVNode(SogCardContent, null, {
        default: _withCtx(() => [
          _createVNode(SogDataLabel, {
            value: props.insurance.evb
          }, null, 8, ["value"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})